var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.00001 0.5C8.51701 0.5 8.12501 0.892 8.12501 1.375V18.8308L1.75851 12.1467C1.42557 11.7971 0.872131 11.7827 0.521256 12.1165C0.171256 12.4499 0.157693 13.0033 0.491068 13.3533L7.76232 20.9872C8.09307 21.318 8.53232 21.5 9.00001 21.5C9.46726 21.5 9.90694 21.318 10.2521 20.9719L17.5085 13.3533C17.8419 13.0033 17.8279 12.4499 17.4783 12.1165C17.1288 11.7827 16.5749 11.7967 16.2415 12.1467L9.87501 18.8588V1.375C9.87501 0.892 9.48301 0.5 9.00001 0.5Z","fill":"white"}));
}

Down.defaultProps = {"width":"18","height":"22","viewBox":"0 0 18 22","fill":"none"};

module.exports = Down;

Down.default = Down;
